export interface RefreshTokenRequestParams {
    refresh_token: string;
}

export interface LoginRequestParams {
    email: string;
    password: string;
    alternate_id?: string;
    captcha_response?: string;
}

export interface TwitterLoginRequestParams {
    oAuthToken: string;
    oAuthVerifier: string;
}

export interface OAuthLoginRequestParams {
    code: string;
    state: string;
}

export interface ProviderAuthRequestParams {
    token: string;
    verifier: string;
}

export enum AuthProviders {
    'Apple' = 'Apple',
    'Discord' = 'Discord',
    'Google' = 'Google',
    'Twitter' = 'Twitter',
}
